<template>
  <el-row :gutter="12">
    <el-col :span="1">
      <div class="custom-label">Item</div>
      <custom-data :data="index + 1" />
    </el-col>
    <el-col :span="1">
      <div class="custom-label">&nbsp;</div>
      <el-button
        type="default"
        plain
        size="default"
        :icon="IconSearch"
        :disabled="!clientes?.length"
        @click="findProducto"
      ></el-button>
    </el-col>

    <custom-data
      label="Cód. equivalente"
      :spanColumn="isET ? 4 : 3"
      :data="producto.Material?.CodigoEquivalente || ''"
    />
    <custom-data
      label="Cód. secundario"
      :spanColumn="isET ? 4 : 3"
      :data="producto.Material?.CodigoAdicional || ''"
    />
    <custom-data
      label="Descripción"
      :spanColumn="isET ? 8 : 4"
      :data="producto.Material?.DescripcionComercial || producto.Descripcion"
    />

    <custom-input
      v-if="!isET"
      v-model="CodigoET"
      label="ET Asociada"
      :spanColumn="3"
      :settings="{ placeholder: 'Nro ET', disabled: true }"
    />
    <!-- <custom-input-number
      v-if="!isET"
      :label="'Cantidad'"
      :spanColumn="3"
      :settings="{ placeholder: 'Cantidad', min: 0, precision: 0, step: 0.01, controls: false }"
      v-model="Cantidad"
    /> -->
    <el-col
      v-if="!isET && isMatrixModule"
      :span="6"
    >
      <div class="custom-label">Cantidades</div>
      <div class="container-product-quantities">
        <div
          v-for="(_, qIndex) in validacionesCantidades"
          :key="qIndex"
          class="qty-item"
        >
          <custom-input-number
            :spanColumn="24"
            :settings="{
              placeholder: `Cant. ${qIndex + 1}`,
              min: 0,
              precision,
              controls: false,
              inputClass: { 'input-error-qty': validacionesCantidades[qIndex] === false },
            }"
            :modelValue="getCantidadParaColumna(qIndex)"
            @update:modelValue="(newValue) => updateCantidadMatrizSegura(newValue, qIndex)"
          />
        </div>
      </div>
    </el-col>
    <custom-input-number
      v-else-if="!isET && !isMatrixModule"
      v-model="Cantidad"
      :label="'Cantidad'"
      :spanColumn="3"
      :settings="{
        placeholder: 'Cantidad',
        min: 0,
        precision,
        step: 0.01,
        controls: false,
        inputClass: { 'input-error': hasQuantityError },
      }"
    />
    <custom-input-number
      v-if="mostrarCantidadBocas"
      v-model="CantidadBocas"
      label="Cant. bocas"
      :spanColumn="3"
      :settings="{ placeholder: 'Bocas', min: 0, precision: 0, controls: false }"
    />
    <el-col :span="mostrarCantidadBocas ? 3 : 4">
      <div class="custom-label">Repetición</div>
      <el-select
        :modelValue="producto.Repeticion"
        size="default"
        value-key="Codigo"
        placeholder="Repetición"
        @change="handlePropiedadProducto($event, 'Repeticion')"
      >
        <el-option
          v-for="(item, indexRepeticion) in repeticionOptions"
          :key="indexRepeticion"
          :label="item.Descripcion"
          :value="item.Codigo"
        />
      </el-select>
    </el-col>
    <el-col :span="2">
      <div class="custom-label">&nbsp;</div>
      <div class="button-position">
        <el-button
          type="danger"
          size="default"
          :icon="IconDelete"
          @click="emit('remove-producto', index)"
        ></el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import {
  computed,
  inject,
} from 'vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomData from '@/shared/components/custom_data.vue';
import IconDelete from '~icons/mdi/delete';
import IconSearch from '~icons/mdi/search';
import { Modules } from '@/enum/modules';
import { useConfiguracionStore } from '@/stores/configuracion-general';
import { storeToRefs } from 'pinia';

const repeticionOptions = [
  { Codigo: 3, Descripcion: 'Repetición con cambio' },
  { Codigo: 2, Descripcion: 'Repetición sin cambio' },
  { Codigo: 1, Descripcion: 'Nuevo' },
];

const props = defineProps({
  producto: { type: Object, required: true },
  index: { type: Number, required: true },
  clientes: { type: Array, default: () => [] },
  validacionesCantidades: { type: Array, default: () => [] },
  hasQuantityError: { type: Boolean, default: false },
  precision: { type: Number, default: 0 },
});

const emit = defineEmits(['update-producto', 'remove-producto', 'find-producto']);
const currentModule = inject('currentModule');
const isET = currentModule === Modules.ESPECIFICACION_TECNICA;

const { cantidadBocasModulos } = storeToRefs(useConfiguracionStore());

// Solo Cotización y OT persisten CantidadBocas; la máscara se evalúa por bit de módulo.
const mostrarCantidadBocas = computed(
  () =>
    [Modules.COTIZACION, Modules.ORDEN_PRODUCCION].includes(currentModule) &&
    (cantidadBocasModulos.value & currentModule) !== 0,
);

const isMatrixModule = computed(() => {
  return [Modules.COTIZACION, Modules.SOLICITUD].includes(currentModule);
});

const matrixKey = computed(() => {
  if (currentModule === Modules.COTIZACION) return 'CotizacionProductoCantidad';
  if (currentModule === Modules.SOLICITUD) return 'SolicitudProductoCantidad';
  return 'Cantidades';
});

const CodigoET = computed({
  get() {
    return props.producto.CodigoEspecificacionTecnica;
  },
  set(valor) {
    handlePropiedadProducto(valor, 'CodigoEspecificacionTecnica');
  },
});

const Cantidad = computed({
  get() {
    return props.producto.Cantidad;
  },
  set(valor) {
    handlePropiedadProducto(valor, 'Cantidad');
  },
});

const CantidadBocas = computed({
  get() {
    return props.producto.CantidadBocas;
  },
  set(valor) {
    handlePropiedadProducto(valor, 'CantidadBocas');
  },
});

const getCantidadParaColumna = (qIndex) => {
  const arrayCantidades = props.producto[matrixKey.value] || [];
  const itemEncontrado = arrayCantidades.find((x) => x.ItemCantidad === qIndex + 1);
  return itemEncontrado ? itemEncontrado.Cantidad : null;
};

const updateCantidadMatrizSegura = (newValue, qIndex) => {
  const productoActualizado = { ...props.producto };
  const nuevoArrayCantidades = [...(productoActualizado[matrixKey.value] || [])];

  const itemCantidadObjetivo = qIndex + 1;

  const indexExistente = nuevoArrayCantidades.findIndex(
    (x) => x.ItemCantidad === itemCantidadObjetivo,
  );

  if (indexExistente >= 0) {
    nuevoArrayCantidades[indexExistente] = {
      ...nuevoArrayCantidades[indexExistente],
      Cantidad: newValue,
    };
  } else {
    nuevoArrayCantidades.push({
      ItemCantidad: itemCantidadObjetivo,
      Cantidad: newValue,
    });
  }

  productoActualizado[matrixKey.value] = nuevoArrayCantidades;
  emit('update-producto', { producto: productoActualizado, index: props.index });
};

const handlePropiedadProducto = (valor, propiedad) => {
  const inmutable = { ...props.producto };
  inmutable[propiedad] = valor;

  emit('update-producto', { producto: inmutable, index: props.index });
};

const findProducto = () => {
  emit('find-producto', props.index);
};
</script>

<style scoped>
.custom-label {
  font-weight: 700;
  color: #111;
}
.container-product-quantities {
  display: flex;
  overflow-x: auto;
  gap: 8px;
  padding-bottom: 5px;
}

.qty-item {
  flex-shrink: 0;
  width: 100px;
}

:deep(.input-error-qty) {
  border: 1px solid #f56c6c !important;
  background-color: #fef0f0;
}
</style>
